import {automationAPI} from "../services/actions/automations";
import {actions_types, getPropsFromAction,} from "../pages/Automations/Edit/Flow/constants/actions";
import {getPropsFromTrigger, triggers_type} from "../pages/Automations/Edit/Flow/constants/triggers";
import {
    normalizeStepName,
    retargetPositionalReferencesAfterRemoval,
    retargetStepNameInValue,
    retargetStepNameToPosition,
    validateStepName
} from "../pages/Automations/Edit/Flow/Actions/utils/functions";
import {findDuplicateRouteNames, slugifyRouteName} from "../pages/Automations/Edit/Flow/Actions/utils/routeNames";
import {getAvailableBranches} from "../pages/Automations/Edit/Flow/Actions/utils/functions";
import {message} from "antd";
import _ from "lodash";
// Types
const START_GET_AUTOMATION = 'core/automation/START_GET_AUTOMATION';
const START_REMOVE_AUTOMATION = 'core/automation/START_REMOVE_AUTOMATION';
const REMOVE_AUTOMATION_ERROR = 'core/automation/REMOVE_AUTOMATION_ERROR';
const END_REMOVE_AUTOMATION = 'core/automation/END_REMOVE_AUTOMATION';
const START_SAVE_AUTOMATION = 'core/automation/START_SAVE_AUTOMATION';
const END_SAVE_AUTOMATION = 'core/automation/END_SAVE_AUTOMATION';
const SAVE_AUTOMATION_ERROR = 'core/automation/SAVE_AUTOMATION_ERROR';
const GET_AUTOMATION = 'core/automation/GET_AUTOMATION';
const GET_AUTOMATION_ERROR = 'core/automation/GET_AUTOMATION_ERROR';
const UPDATE_BASIC_DATA_AUTOMATION_ERROR = 'core/automation/UPDATE_BASIC_DATA_AUTOMATION_ERROR';
const ADD_ACTION_TO_AUTOMATION = 'core/automation/ADD_ACTION_TO_AUTOMATION';
const REMOVE_ACTION_FROM_AUTOMATION = 'core/automation/REMOVE_ACTION_FROM_AUTOMATION';
const UPDATE_ACTION_CUSTOM_NAME_FROM_AUTOMATION = 'core/automation/UPDATE_ACTION_CUSTOM_NAME_FROM_AUTOMATION';
const UPDATE_ACTION_BRANCH_FROM_AUTOMATION = 'core/automation/UPDATE_ACTION_BRANCH_FROM_AUTOMATION';
const RENAME_ROUTE_PATH_IN_AUTOMATION = 'core/automation/RENAME_ROUTE_PATH_IN_AUTOMATION';
const UPDATE_BASIC_DATA_AUTOMATION = 'core/automation/UPDATE_BASIC_DATA_AUTOMATION';
const START_UPDATE_BASIC_DATA_AUTOMATION = 'core/automation/START_UPDATE_BASIC_DATA_AUTOMATION';
const CHANGE_CURRENT_ACTION_STEP = 'core/automation/CHANGE_CURRENT_ACTION_STEP';
const UPDATE_TRIGGER_FROM_AUTOMATION = 'core/automation/UPDATE_TRIGGER_FROM_AUTOMATION';
const UPDATE_TYPE_TRIGGER_FROM_AUTOMATION = 'core/automation/UPDATE_TYPE_TRIGGER_FROM_AUTOMATION';
const OPEN_MODAL_SNIPPETS = 'core/automation/OPEN_MODAL_SNIPPETS';
const CLOSE_MODAL_SNIPPETS = 'core/automation/CLOSE_MODAL_SNIPPETS';
const UPDATE_ACTION_FROM_AUTOMATION = 'core/automation/UPDATE_ACTION_FROM_AUTOMATION';
const UPDATE_TRIGGER_SNIPPETS = 'core/automation/UPDATE_TRIGGER_SNIPPETS';
const UPDATE_ACTION_SNIPPETS = 'core/automation/UPDATE_ACTION_SNIPPETS';
const UPDATE_ALL_ACTION_SNIPPETS = 'core/automation/UPDATE_ALL_ACTION_SNIPPETS';

// Reducer
const initialState = {
    loading: false,
    automation: null,
    trigger: null,
    actions: [],
    actionStep: -1,
    error: null,
    snippets: {
        field: {
            label: null,
            name: null,
        },
        data: [],
        showModal: false,
    },
};

export default function automationCenterReducer(state = initialState, action) {
    switch (action.type) {
        case START_REMOVE_AUTOMATION:
        case START_SAVE_AUTOMATION:
        case START_UPDATE_BASIC_DATA_AUTOMATION:
        case START_GET_AUTOMATION:
            return {
                ...state,
                loading: true,
                error: null
            }
        case GET_AUTOMATION: {
            const {snippets:initialSnippetsData} = action.payload;
            initialSnippetsData[-1] = action.payload.triggerSnippets
            const loadedActions = action.payload.actions ?? [];
            // O passo selecionado é posicional: ele só significa alguma coisa
            // dentro da automação em que foi escolhido. Carregar outra (o store
            // sobrevive à navegação entre telas) deixava o índice antigo
            // apontando para uma etapa que não existe aqui — e o primeiro
            // clique no canvas salvava nesse índice inexistente. Recarregar a
            // mesma automação (depois de salvar) preserva a seleção.
            const isSameAutomation = state.automation?.id === action.payload.id;
            const keepStep = isSameAutomation && state.actionStep < loadedActions.length;
            return {
                ...state,
                automation: _.omit(action.payload,[
                    'triggerSnippets',
                    'snippets'
                ]),
                trigger: action.payload.trigger || null,
                actions: loadedActions,
                actionStep: keepStep ? state.actionStep : -1,
                loading: false,
                snippets: {
                    ...state.snippets,
                    data: initialSnippetsData
                }
            };
        }
        case ADD_ACTION_TO_AUTOMATION: {
            const {actionData, context} = action.payload;
            const newActions = [...state.actions];
            // O canvas informa depois de qual passo inserir; sem contexto,
            // insere após o passo selecionado (comportamento original).
            const afterIndex = context && context.afterIndex !== undefined
                ? context.afterIndex
                : state.actionStep;
            const insertIndex = afterIndex + 1;
            // Rota do passo novo: a do conector clicado no canvas; sem
            // contexto, herda a rota do passo anterior (continua a sequência).
            const inheritedBranch = afterIndex > -1
                ? (state.actions[afterIndex]?.branch ?? null)
                : null;
            const branch = context && context.branch !== undefined
                ? context.branch
                : inheritedBranch;
            newActions.splice(insertIndex, 0, {
                ...actionData,
                branch,
            });
            // Mantém snippets.data alinhado com os índices das actions; o
            // spread perde a chave [-1] (gatilho), então ela é preservada à mão.
            const snippetsDataAdded = [...state.snippets.data];
            snippetsDataAdded[-1] = state.snippets.data[-1];
            snippetsDataAdded.splice(insertIndex, 0, []);
            return {
                ...state,
                actions: newActions,
                actionStep: insertIndex,
                snippets: {
                    ...state.snippets,
                    data: snippetsDataAdded
                }
            };
        }
        case CHANGE_CURRENT_ACTION_STEP:
            let stepToChange = action.payload;
            if (action[stepToChange] !== null || stepToChange === -1) {
                return {
                    ...state,
                    actionStep: stepToChange,
                }
            } else {
                return state
            }
        case REMOVE_ACTION_FROM_AUTOMATION:
            let stepToRemove = action.payload;
            const actionsToRemoved = [...state.actions];
            actionsToRemoved.splice(stepToRemove, 1);
            // Remover renumera as etapas seguintes, então quem as referenciava
            // pela posição precisa acompanhar — senão a referência continua
            // escrita igual e passa a apontar para outra etapa, em silêncio.
            for (let index = 0; index < actionsToRemoved.length; index++) {
                actionsToRemoved[index] = {
                    ...actionsToRemoved[index],
                    config: retargetPositionalReferencesAfterRemoval(
                        actionsToRemoved[index].config,
                        stepToRemove + 1
                    )
                };
            }
            const snippetsDataToRemoved = [...state.snippets.data];
            // O spread perde a chave [-1] (anotações do gatilho); preserva.
            snippetsDataToRemoved[-1] = state.snippets.data[-1];
            snippetsDataToRemoved.splice(stepToRemove, 1);
            return {
                ...state,
                actions: actionsToRemoved,
                actionStep: stepToRemove - 1,
                snippets: {
                    ...state.snippets,
                    data: snippetsDataToRemoved
                }
            }
        case UPDATE_ACTION_CUSTOM_NAME_FROM_AUTOMATION: {
            const {step, name, previousName} = action.payload;
            const shouldRetarget = !!previousName && previousName !== name;
            const newActionsUpdated = state.actions.map((item, index) => {
                if (index === step) {
                    return {...item, name};
                }
                // Renomear não pode quebrar quem já aponta para a etapa: as
                // referências pelo nome antigo passam a usar o novo — ou, se o
                // nome foi apagado, a posição da etapa. Só passos posteriores
                // podem referenciá-la.
                if (shouldRetarget && index > step) {
                    const config = name
                        ? retargetStepNameInValue(item.config, previousName, name)
                        : retargetStepNameToPosition(item.config, previousName, step + 1);
                    return {...item, config};
                }
                return item;
            });
            return {
                ...state,
                actions: newActionsUpdated
            }
        }
        case UPDATE_ACTION_BRANCH_FROM_AUTOMATION:
            const {step: branchStep, branch} = action.payload;
            const actionsWithBranch = state.actions.map((item, index) =>
                index === branchStep ? {...item, branch: branch ?? null} : item
            );
            return {
                ...state,
                actions: actionsWithBranch
            }
        case RENAME_ROUTE_PATH_IN_AUTOMATION: {
            const {oldPath, newPath} = action.payload;
            // O caminho renomeado e tudo que está aninhado dentro dele
            // ("retirada" → "entrega" leva junto "retirada.ia").
            const renamePath = (path) => {
                if (path === oldPath) return newPath;
                if (typeof path === 'string' && path.startsWith(`${oldPath}.`)) {
                    return newPath + path.slice(oldPath.length);
                }
                return path;
            };
            const renamedActions = state.actions.map((item) => {
                const branch = item.branch ? renamePath(item.branch) : item.branch;
                // As origens de uma junção são caminhos completos: acompanham
                // a renomeação como o `branch` acompanha.
                const sources = item.type === 'merge' && Array.isArray(item.config?.sources)
                    ? item.config.sources.map(renamePath)
                    : null;
                if (branch === item.branch && !sources) return item;
                return {
                    ...item,
                    branch,
                    ...(sources ? {config: {...item.config, sources}} : {})
                };
            });
            return {
                ...state,
                actions: renamedActions
            }
        }
        case UPDATE_BASIC_DATA_AUTOMATION:
            return {
                ...state,
                automation: {
                    ...state.automation,
                    name: action.payload.name,
                    description: action.payload.description,
                    active: action.payload.active
                },
                error: null,
                loading: false
            }
        case REMOVE_AUTOMATION_ERROR:
        case GET_AUTOMATION_ERROR:
        case UPDATE_BASIC_DATA_AUTOMATION_ERROR:
        case SAVE_AUTOMATION_ERROR:
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        case UPDATE_TRIGGER_FROM_AUTOMATION:
            return {
                ...state,
                trigger: {
                    ...state.trigger,
                    config: {
                        ...state.trigger.config,
                        ...action.payload
                    }
                },
            }
        case UPDATE_TYPE_TRIGGER_FROM_AUTOMATION:
            return {
                ...state,
                trigger: {
                    type: action.payload,
                    config: null
                }
            }
        case OPEN_MODAL_SNIPPETS:
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    field: {
                        ...state.snippets.field,
                        label: action.payload.label,
                        name: action.payload.name,
                        isCode: action.payload.isCode,
                        acceptEntryLoop:action.payload.acceptEntryLoop,
                        wholeField: action.payload.wholeField,
                    },
                    showModal: true
                },
            }
        case CLOSE_MODAL_SNIPPETS:
            // O Drawer usa `destroyOnHidden`: o conteúdo continua montado durante
            // a animação de saída. Zerar o campo aqui fazia as seções escondidas
            // por `isCode`/`acceptEntryLoop` (os passos do laço e os helpers)
            // voltarem a renderizar por um instante enquanto a tela fechava. O
            // descritor fica como está — OPEN_MODAL_SNIPPETS reescreve tudo.
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    showModal: false
                }
            }
        case UPDATE_ACTION_FROM_AUTOMATION:
            const {data, stepUpdated} = action.payload;
            const updatedActions = state.actions.map((action, index) => {
                if (index === stepUpdated) {
                    return {
                        ...action,
                        config: {
                            ...action.config,
                            ...data
                        }
                    };
                }
                return action;
            });

            return {
                ...state,
                actions: updatedActions
            };
        case UPDATE_TRIGGER_SNIPPETS:
            const newDataSnippets = state.snippets.data;
            newDataSnippets[-1] = action.payload;
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    data: newDataSnippets
                }
            }
        case UPDATE_ACTION_SNIPPETS:
            const {actionStep, snippets} = action.payload;
            const newDataActionSnippets = state.snippets.data;
            newDataActionSnippets[actionStep] = snippets;
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    data: newDataActionSnippets
                }
            }
        case END_SAVE_AUTOMATION:
            return {
                loading: false,
                ...state
            }
        case UPDATE_ALL_ACTION_SNIPPETS:
            const {snippets:snippetsData} = action.payload;
            return {
                ...state,
                snippets: {
                    ...state.snippets,
                    data: snippetsData
                }
            }
        case END_REMOVE_AUTOMATION:
            return initialState;
        default:
            return state;
    }
}

export const getAutomationById = (id,navigate) => async (dispatch) => {
    try {
        dispatch({type: START_GET_AUTOMATION})
        const {status, data} = await automationAPI.getOne(id);
        if (status === 200 && data) {
            const type = data.trigger && data.trigger.type ? data.trigger.type : null;
            if(type){
                const triggerData = triggers_type.find((trigger) => trigger.type === type);
                if(triggerData){
                    data.trigger = {
                        ...data.trigger,
                        ...triggerData
                    }
                }
            }
            if(data.actions && data.actions.length > 0){
                data.actions = data.actions.map((action) => {
                    if(action.type){
                        const actionData= actions_types.find((item) => item.type === action.type);
                        if(actionData){
                            return {
                                ...action,
                                ...actionData,
                                // O nome customizado persistido no backend vira o
                                // `name` que o editor usa para exibição.
                                name: action.customName ?? action.name ?? null,
                            }
                        }else{
                            return action;
                        }

                    }
                    return action;
                })
            }
            data.snippets = await Promise.all(data.actions.map((item) => getPropsFromAction(item)));
            data.triggerSnippets =  await getPropsFromTrigger(data.trigger);
            dispatch({type: GET_AUTOMATION, payload: data});
        } else {
            dispatch({type: GET_AUTOMATION_ERROR, payload: data.message});
            navigate('/automacoes');
        }
    } catch (error) {
        dispatch({type: GET_AUTOMATION_ERROR, payload: error.message});
        navigate('/automacoes');
    }
};

export const addActionToAutomaion = (action, context = null) => async (dispatch, getState) => {
    const {automation: {actionStep}} = getState();
    const afterIndex = context && context.afterIndex !== undefined
        ? context.afterIndex
        : actionStep;
    dispatch({type: ADD_ACTION_TO_AUTOMATION, payload: {actionData: action, context}});
    // Preenche as anotações (⚡) do passo recém-criado — sem isso, adicionar
    // passos em sequência deixava snippets.data com buracos.
    dispatch(updateActionSnippets({step: afterIndex + 1}));
};

export const changeActionCurrentStep = (step) => async (dispatch) => {
    dispatch({type: CHANGE_CURRENT_ACTION_STEP, payload: step});
};

export const removeActionFromAutomation = (step) => async (dispatch) => {
    dispatch({type: REMOVE_ACTION_FROM_AUTOMATION, payload: step});
};

/**
 * Remove várias etapas de uma vez (as inalcançáveis, oferecidas no salvar).
 *
 * Da maior posição para a menor: cada remoção renumera as etapas seguintes e
 * reescreve quem as referenciava pela posição, então tirar primeiro as do fim
 * mantém as posições restantes válidas. Em ordem crescente, a segunda remoção
 * já apagaria a etapa errada.
 */
export const removeActionsFromAutomation = (steps) => (dispatch) => {
    [...new Set(steps)]
        .sort((a, b) => b - a)
        .forEach((step) => dispatch({type: REMOVE_ACTION_FROM_AUTOMATION, payload: step}));
};

export const updateNameActionFromAutomation = (step, name) => async (dispatch, getState) => {
    const {automation: {actions}} = getState();
    const currentAction = actions[step];
    if (!currentAction) return;

    const nextName = normalizeStepName(name);
    const previousName = normalizeStepName(currentAction.name);
    if (nextName === previousName) return;

    // O nome vira identificador de referência: recusar aqui evita gravar uma
    // automação em que `steps.[nome]` seja ambíguo (o backend recusaria o save).
    const error = validateStepName(actions, step, nextName);
    if (error) {
        message.error(error, 8);
        return;
    }

    dispatch({
        type: UPDATE_ACTION_CUSTOM_NAME_FROM_AUTOMATION, payload: {
            step,
            name: nextName || null,
            previousName
        }
    });
};

export const updateActionBranchFromAutomation = (step, branch) => async (dispatch) => {
    dispatch({
        type: UPDATE_ACTION_BRANCH_FROM_AUTOMATION, payload: {
            step,
            branch
        }
    });
    // As anotações do passo dependem do caminho dele: só um passo dentro de um
    // caminho publica `skipped`. Sem recalcular, tirar ou pôr o passo num
    // caminho só se refletiria na lista depois de recarregar a automação.
    dispatch(updateActionSnippets({step}));
};

/**
 * Renomeia um caminho em toda a automação: no `branch` dos passos que rodam
 * nele (e nos caminhos aninhados dentro dele) e nas origens das junções que o
 * unem. É o que mantém o fluxo íntegro quando o usuário troca o nome de um
 * caminho no editor do desvio ou da junção.
 */
export const renameRoutePathInAutomation = (oldPath, newPath) => async (dispatch) => {
    dispatch({
        type: RENAME_ROUTE_PATH_IN_AUTOMATION, payload: {oldPath, newPath}
    });
};

export const updateBasicDataAutomation = (id, payload) => async (dispatch) => {
    try {
        dispatch({type: START_UPDATE_BASIC_DATA_AUTOMATION})
        const {status, data} = await automationAPI.updateOne(id, payload);
        if (status === 200 && data) {
            dispatch({type: UPDATE_BASIC_DATA_AUTOMATION, payload: payload});
        } else {
            dispatch({type: UPDATE_BASIC_DATA_AUTOMATION_ERROR, payload: data.message});
        }
    } catch (error) {
        dispatch({type: UPDATE_BASIC_DATA_AUTOMATION_ERROR, payload: error.message});
    }
};

export const updateTriggerConfigAutomation = ({config}) => async (dispatch, getState) => {
    dispatch({type: UPDATE_TRIGGER_FROM_AUTOMATION, payload: config});
    const state = getState();
    const trigger = state.automation.trigger
    dispatch(updateTriggerSnippets(trigger))
};

export const updateTypeTriggerAutomation = ({type}) => async (dispatch, getState) => {
    dispatch({type: UPDATE_TYPE_TRIGGER_FROM_AUTOMATION, payload: type});
    const state = getState();
    const trigger = state.automation.trigger
    dispatch(updateTriggerSnippets(trigger))
};

export const updateTriggerSnippets = (trigger) => async (dispatch) => {
    const props = await getPropsFromTrigger(trigger);
    dispatch({type: UPDATE_TRIGGER_SNIPPETS, payload: props});
};

export const openOrCloseModalSnippets = ({action, fieldName = null, fieldLabel = null,isCode = false,acceptEntryLoop = true,wholeField = false}) => async (dispatch) => {
    if (action) {
        dispatch({type: OPEN_MODAL_SNIPPETS, payload: {name: fieldName, label: fieldLabel,isCode,acceptEntryLoop,wholeField}});
    } else {
        dispatch({type: CLOSE_MODAL_SNIPPETS});
    }

};

/**
 * Identificador da rota que uma junção declara, derivado do rótulo pela mesma
 * regra dos caminhos do desvio — é ele que vai para o `branch` dos passos da
 * continuação comum.
 *
 * Esse identificador é o único vínculo entre a junção e os passos que rodam
 * depois dela. Se ele ficar vazio (rótulo apagado) ou passar a apontar para um
 * caminho que já existe, os passos se soltam — e, como o rótulo anterior já se
 * foi, não sobra nada para reconectá-los. Nesses dois casos o identificador
 * atual permanece: o rótulo digitado aparece normalmente no editor e os passos
 * continuam no lugar. Ele volta a acompanhar o rótulo assim que este gerar um
 * identificador próprio e livre.
 */
const resolveMergeRouteName = (actions, step, prefix, currentName, label) => {
    const slug = slugifyRouteName(label);
    if (!slug) return currentName ?? '';

    const alreadyDeclared = getAvailableBranches(actions, step)
        .some((item) => item.value === prefix + slug);

    return alreadyDeclared ? (currentName ?? '') : slug;
};

export const updateActionFromAutomation = ({step, data}) => async (dispatch, getState) => {
    const {automation: {actions: currentActions}} = getState();
    const currentAction = currentActions[step];
    const prefix = currentAction?.branch ? `${currentAction.branch}.` : '';

    const nextData = currentAction?.type === 'merge'
        ? {
            ...data,
            name: resolveMergeRouteName(
                currentActions,
                step,
                prefix,
                currentAction.config?.name,
                data?.label
            )
        }
        : data;

    // Renomear um caminho muda o identificador (slug) da rota; os passos
    // atribuídos a ela — e as junções que a unem — ficariam órfãos. Propaga a
    // renomeação antes de aplicar a mudança.
    if (
        currentAction &&
        currentAction.type === 'switch' &&
        Array.isArray(data?.routes) &&
        Array.isArray(currentAction.config?.routes) &&
        // Só com o mesmo tamanho a comparação posicional é inequívoca
        // (adicionar/remover caminho não é renomeação).
        data.routes.length === currentAction.config.routes.length
    ) {
        // Um identificador repetido não distingue caminho nenhum: renomear um
        // dos dois reescreveria de uma vez o `branch` dos passos de ambos,
        // misturando-os sem volta. O editor não deixa mais chegar a esse estado
        // — o identificador só acompanha o rótulo quando o resultado está livre
        // —, mas automações salvas antes dessa regra podem já estar assim, e
        // renomear a partir daí espalharia o estrago. Com nome duplicado dos
        // dois lados, então, não propaga: os passos ficam onde estão, o editor
        // sinaliza a duplicidade e o salvamento recusa.
        const duplicatedBefore = findDuplicateRouteNames(currentAction.config.routes);
        const duplicatedAfter = findDuplicateRouteNames(data.routes);

        currentAction.config.routes.forEach((oldRoute, index) => {
            const newRoute = data.routes[index];
            if (!oldRoute?.name || !newRoute?.name) return;
            if (oldRoute.name === newRoute.name) return;
            if (duplicatedBefore.has(oldRoute.name) || duplicatedAfter.has(newRoute.name)) return;
            dispatch(renameRoutePathInAutomation(
                prefix + oldRoute.name,
                prefix + newRoute.name
            ));
        });
    }

    if (
        currentAction?.type === 'merge' &&
        currentAction.config?.name &&
        nextData.name &&
        currentAction.config.name !== nextData.name
    ) {
        // `resolveMergeRouteName` já garantiu que o identificador mudou para um
        // que existe e está livre: aqui a renomeação é sempre segura.
        dispatch(renameRoutePathInAutomation(
            prefix + currentAction.config.name,
            prefix + nextData.name
        ));
    }

    dispatch({
        type: UPDATE_ACTION_FROM_AUTOMATION, payload: {data: nextData, stepUpdated: step}
    });
    dispatch(updateActionSnippets({step}))
};

export const saveAutomationActionsAndTrigger = () => async (dispatch, getState) => {
    const { automation: { trigger, actions, automation } } = getState();
    dispatch({ type: START_SAVE_AUTOMATION });
    try {
        if (trigger) {
            const { config = null, type = null } = trigger;
            const configTrigger = omitPropsFromTrigger(type, config);

            const { status: statusTrigger, data: dataTrigger } = await automationAPI.saveTrigger(automation.id, configTrigger, type);
            if (![200, 201].includes(statusTrigger)) throw new Error(dataTrigger);
        }

        if(actions){
            const actionsData = actions.map((item, index) => ({
                step: index,
                type: item.type,
                // Nome em branco não é nome: a etapa volta a valer pelo nome
                // padrão do tipo, e a referência a ela, pela posição.
                customName: normalizeStepName(item.name ?? item.customName) || null,
                branch: item.branch ?? null,
                config: omitPropsFromActions(item.type, item.config),
            }));

            const { status: statusActions, data: dataActions } = await automationAPI.saveActions(automation.id, actionsData);
            if (![200, 201].includes(statusActions)) throw new Error(dataActions?.message ?? dataActions);

            // Validações não-bloqueantes do backend (ex.: rotas sobrepostas
            // em modo "primeira").
            if (dataActions && Array.isArray(dataActions.warnings)) {
                dataActions.warnings.forEach((warning) => message.warning(warning, 8));
            }
        }

        dispatch({ type: END_SAVE_AUTOMATION });
        dispatch(getAutomationById(automation.id));

    } catch (error) {
        // Validações do backend (ex.: rota inexistente, referência a etapa
        // que não existe) chegam como 400 com a mensagem em response.data.
        const backendMessage = error?.response?.data?.message;
        const errorMessage = Array.isArray(backendMessage)
            ? backendMessage.join(' ')
            : (backendMessage ?? error.message);
        message.error(errorMessage, 8);
        dispatch({ type: SAVE_AUTOMATION_ERROR, payload: errorMessage });
    }
};


export const deleteAutomation = (id, navigate) => async (dispatch) => {
    dispatch({type: START_REMOVE_AUTOMATION});
    try {
        const {status, data} = await automationAPI.deleteOne(id);
        if (200 === status) {
            dispatch({type: END_SAVE_AUTOMATION});
            navigate('/automacoes');
        } else {
            throw new Error(data);
        }
    } catch (error) {
        dispatch({type: REMOVE_AUTOMATION_ERROR, payload: error.message});
    }
}

export const updateActionSnippets = ({step}) => async (dispatch,getState) => {
    const state = getState();
    const {actions} = state.automation;
    // Sem etapa nessa posição não há o que anotar, e gravar mesmo assim abriria
    // um buraco em snippets.data — os índices deixariam de acompanhar `actions`.
    if (!actions[step]) return;
    const snippets = await getPropsFromAction(actions[step]);
    dispatch({type: UPDATE_ACTION_SNIPPETS, payload: {actionStep:step, snippets}});
};

const omitPropsFromActions = (type,config) => {
    let props  = [
        "propsInput",
        "propsOutput",
        "icon",
        "description"
    ];
    switch (type) {
        // case "send_mail":
        // case "create_row":
        // case "update_row":
        // case "delete_row":
        // case "condition":
        // case "script":
        // case "delay":
        // case "query":
        // case "start_automation":
        //  break;
        default:
            break;
    }
    return _.omit(config,props);
}

const omitPropsFromTrigger = (type,config) => {
    let props  = [
    ];
    switch (type) {
        // case "row_created":
        // case "row_updated":
        // case "row_deleted":
        case "webhook":
            props.push("webhookData");
        // case "cron_trigger":
        //  break;
        default:
            break;
    }
    return _.omit(config,props);
}
